export default __webpack_public_path__ + "static/media/01_sazenice-osetrena-repelentem_Junek-min.af3a5c24.jpg";